import React from 'react';
import { Layout, PageHeader, Row, Col } from 'antd';
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    HomeOutlined,
    SkinOutlined,
    ShoppingCartOutlined,
    CarOutlined,
    UsergroupAddOutlined,
    CodeSandboxOutlined,
    TransactionOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import { Link, browserHistory } from 'react-router';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';

const CardBox = styled.div`
    border: 1px solid #a5b1c2;
    margin-top: 20px;
    padding: 10px;
    border : 5px;
`;
const Label = styled.p`
    margin-bottom: 2px;
    font-weight: bold;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
`;
const { Header, Sider, Content } = Layout;

function Dashboard() {
    const counter = useSelector(state => state.counter)
    const dispatch = useDispatch();

    const logout = async () => {
        await localStorage.clear()
        browserHistory.push('/')
    }

    return (
        <Content
            className="site-layout-background"
            style={{
                margin: '24px 16px',
                padding: 24,
                minHeight: 280,
            }}
        >

           <CardBox >
               <Label>Cooming Soon</Label>
           </CardBox>
        </Content>
    )
}

export default Dashboard;